var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulker2 = function SvgBulker2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "auto",
      fill: "currentColor"
    },
    viewBox: "0 0 430 430"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12.04
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#08A88A",
    d: "M91.887 250.64H20.941M222.093 206.915l52.436-65.404m0 0v53.03m-13.343 13.686 13.343-13.343 13.343 13.343m-66.779 41.412v-81.012h-26.686v81.012M342.093 206.915l52.749-65.466v53.03m-13.343 13.687 13.343-13.344 13.344 13.344m-67.092 41.474v-81.012h-26.686v81.012M103.277 168.355h-4.544m4.544 26.484h-4.544"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121331",
    d: "m74.444 141.597 53.248.072v80.095m-80.06-106.782L34.289 221.728m40.03.036V141.54v.024-26.582H20.945"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121331",
    d: "M408.386 250.64H170.361c-8.732 0-15.81-7.078-15.81-15.81v-13.08H21.114l.002 42.405c.001 28.166 22.834 50.998 51 50.998H381.73z"
  }))));
};
export default SvgBulker2;